import { useSearchParams } from 'react-router-dom';
import { Skeleton } from '@/components/ui/Feedback';
import { useProjects, useSite } from '../hooks';
import { ProjectCard } from '../ProjectCard';
import { Reveal } from '../Reveal';
import { Seo } from '../Seo';
import { CategoryFilter } from '../sections/Work';
import { useLocale } from '../i18n';

export function WorkPage() {
  const [params, setParams] = useSearchParams();
  const category = params.get('category') ?? undefined;
  const { data: site } = useSite();
  const { data, isLoading, isError } = useProjects({ category });
  const s = site?.settings;
  const { t } = useLocale();

  return (
    <div className="container-site pt-[104px] pb-20 md:pt-[140px]">
      <Seo
        title={`${s?.workHeading ?? t.work.seoTitle} — ${s?.ownerName ?? ''}`}
        description={s?.workIntro ?? s?.metaDescription}
        path="/work"
      />
      <div className="flex flex-col gap-8 md:flex-row md:items-end md:justify-between">
        <div>
          <p className="eyebrow">{t.work.eyebrow}</p>
          <h1 className="mt-3 text-[clamp(3rem,1.8rem+5vw,6rem)] leading-[0.9] font-black tracking-[-0.01em]">
            {s?.workHeading ?? t.work.title}
          </h1>
          {s?.workIntro && <p className="mt-5 max-w-xl text-body text-graphite">{s.workIntro}</p>}
        </div>
        <CategoryFilter
          categories={site?.categories ?? []}
          labels={site?.categoryLabels}
          value={category}
          onChange={(c) => setParams(c ? { category: c } : {}, { replace: true })}
        />
      </div>
      {isLoading ? (
        <div className="mt-14 grid gap-10 md:grid-cols-2">
          {[0, 1, 2, 3].map((i) => (
            <Skeleton key={i} className="aspect-[16/11] rounded-[28px]" />
          ))}
        </div>
      ) : isError ? (
        <p className="mt-14 text-muted">{t.work.loadError}</p>
      ) : !data?.length ? (
        <p className="mt-14 text-body text-muted">{t.work.emptyCategory}</p>
      ) : (
        <ul className="mt-14 grid gap-x-8 gap-y-14 md:grid-cols-2">
          {data.map((p, i) => (
            <Reveal as="li" key={p.id} delay={(i % 2) * 0.08}>
              <ProjectCard project={p} />
            </Reveal>
          ))}
        </ul>
      )}
    </div>
  );
}
